import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../images/logo.svg";
import "./Header.css";


const serviceItems = [
  {
    title: "CQC Services",
    to: "/Sub-Pages/CQC_Services",
  },
  {
    title: "Care Home Sales",
    to: "/Sub-Pages/Care_Sale",
  },
  {
    title: "Accounting",
    to: "/Sub-Pages/Acc_Capital",
  },
  {
    title: "Software",
    to: "/Sub-Pages/Soft_Rota",
  },
  {
    title: "Operational Management",
    to: "/Sub-Pages/Opera_fullManag",
  },
];



const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
   const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

    const closeMenu = () => {
    setMenuActive(false);
    setServicesOpen(false);
  };


  return (
    <header className={`navbar ${isScrolled ? "black" : ""}`}>
      {/* Logo */}
      <div className="logo">
        <NavLink to="/" end onClick={closeMenu}>
          <img src={Logo} alt="logo" />
        </NavLink>
      </div>

      {/* Mobile Menu Icon */}
      <div className="menu">
        <h4 onClick={() => setMenuActive(!menuActive)}>☰</h4>
      </div>

      {/* Navigation */}
      <nav className={`nav-links ${menuActive ? "active" : ""}`}>
        <NavLink to="/" end onClick={closeMenu}>
          Home
        </NavLink>

        <NavLink to="/about" onClick={closeMenu}>
          About Us
        </NavLink>

         {/* Our Services Dropdown */}
        <div
          className="services-dropdown"
          onMouseEnter={() => setServicesOpen(true)}
          onMouseLeave={() => setServicesOpen(false)}
        >
          <button
            type="button"
            className="services-dropdown-btn"
            onClick={() => setServicesOpen(!servicesOpen)}
          >
            
           <NavLink to="/OurServices" onClick={closeMenu}>
            Our Services
            </NavLink>
            <span className="dropdown-arrow">▸</span>
          </button>

          {servicesOpen && (
            <div className="services-dropdown-menu">
              {serviceItems.map((item) => (
                <NavLink
                  key={item.title}
                  to={item.to}
                  onClick={closeMenu}
                  className="service-dropdown-item"
                >
                  <span>{item.title}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>
        <NavLink to="/insights" onClick={closeMenu} className="next">
          Insights
        </NavLink>

        <NavLink to="/faqs" onClick={closeMenu}>
          FAQs
        </NavLink>

        <NavLink to="/Registration" onClick={closeMenu}>
          CQC Registration
        </NavLink>
      </nav>

      {/* CTA Buttons */}
      <div className="nav-actions">
        <a
          href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U"
          className="Navbar-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Product brochure</span>
        </a>

        <a href="tel:+4416033203325" className="Navbar-btn">
          Speak to Our Team
        </a>
      </div>
    </header>
  );
};

export default Header;